module.exports = __webpack_public_path__ + "static/img/city1.3281415.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contact/city1.png
// module id = rZYU
// module chunks = 1